import { createSelector } from "reselect";

export const getDashboardCount = createSelector(
	(state) => state.commonReducer,
	(detail) => detail
);